/* El reloj del viaje. Para probar antes de salir, `?sim=2026-10-17T18:40` fija la hora
   (y el reloj sigue corriendo desde ahí). Sin `?sim`, la hora real del móvil. */
import { useEffect, useState, useSyncExternalStore } from 'react';

const DIA_MS = 864e5;
const cargado = Date.now();
let sim: string | null = new URLSearchParams(location.search).get('sim');
if (sim && Number.isNaN(new Date(sim).getTime())) sim = null;
const oyentes = new Set<() => void>();
/** El selector «Simular» solo sale si se entró con `?sim=`: en el viaje, la hora es la real. */
export const conSimulador = sim !== null;

export const simulado = () => sim;
export function simular(valor: string | null) {
  sim = valor && !Number.isNaN(new Date(valor).getTime()) ? valor : null;
  oyentes.forEach(f => f());
}
export const useSimulado = () => useSyncExternalStore(f => { oyentes.add(f); return () => oyentes.delete(f); }, () => sim);

export const ahora = () => (sim ? new Date(new Date(sim).getTime() + (Date.now() - cargado)) : new Date());
/** El día del viaje empieza a las 05:00: a la 01:30 sigues en la noche de ayer (karaoke, «Noche abierta»). */
export const CORTE = 5 * 60;

/* Y un día no acaba mientras le queden bloques: el D1 (salida de Madrid) termina el 11 a las 17:30
   en el hotel de Osaka, aunque a las 11:10 de ese día, al aterrizar en Haneda, el calendario ya diga D2. */
let dias: { inicio: string; fin: (n: number) => number | undefined } | null = null;
export const registrarDias = (inicio: string, fin: (n: number) => number | undefined) => { dias = { inicio, fin }; };

function reloj(inicio = dias?.inicio): { n: number; min: number } {
  const t = ahora(), m = t.getHours() * 60 + t.getMinutes();
  let n = 0;
  if (inicio) {
    const [a, me, d] = inicio.split('-').map(Number);
    n = Math.round((new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime() - new Date(a, me - 1, d).getTime()) / DIA_MS) + 1;
  }
  if (m < CORTE || (inicio && (dias?.fin(n - 1) ?? 0) > m + 1440)) return { n: n - 1, min: m + 1440 };
  return { n, min: m };
}

/** Minuto del día del viaje: de 0 a 1439 y, si sigue el día anterior, 1440 en adelante (como sus bloques de después de medianoche). */
export const ahoraMin = () => reloj().min;

/** Número de día del viaje (1 = el día de salida); < 1 antes de salir, > total a la vuelta. */
export const hoyN = (inicio: string) => reloj(inicio).n;

/** Vuelve a pintar cada `ms` (lo que depende de la hora: «ahora», «en 20 min»…). */
export function useTic(ms = 30_000) {
  const [, setT] = useState(0);
  useEffect(() => { const i = setInterval(() => setT(t => t + 1), ms); return () => clearInterval(i); }, [ms]);
}
